import React, { useState } from 'react';
import { ChevronDown, Trash2, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import apiClient from '@/utils/api';
import { EnrolModal } from './WorkflowDialogs';

export const ProfileManagement = ({ student, user, onChanged, onDeleted }) => {
  const [enrol, setEnrol] = useState(false), [busy, setBusy] = useState(false);
  const canEnrol = !student.is_converted && student.workflow_version !== 'pilot' && student.workflow_stage !== 'closed' && !['bad_lead', 'dead_lead'].includes(student.lead_status);
  if (!['admin', 'operating_head', 'team_leader'].includes(user?.role) || (!canEnrol && user.role !== 'admin')) return null;
  return <details className="profile-disclosure" data-testid="profile-admin-actions">
    <summary data-testid="profile-admin-actions-toggle">{user.role === 'admin' ? 'Admin actions' : 'Management actions'}<ChevronDown className="w-4 h-4" /></summary>
    <div className="flex flex-wrap gap-2 py-2">
      {canEnrol && <Button variant="outline" onClick={() => setEnrol(true)} data-testid="wf-enrol-btn"><UserPlus className="w-4 h-4 mr-2" />Enrol in Telecaller workflow</Button>}
      {user.role === 'admin' && <Button variant="outline" disabled={busy} className="text-red-700" data-testid="delete-lead-button" onClick={async () => {
        if (!window.confirm(`Permanently delete "${student.full_name}"? This cannot be undone.`)) return;
        setBusy(true);
        try { await apiClient.delete(`/students/${student.id}`); toast.success('Lead deleted'); onDeleted(); }
        catch (e) { toast.error(e.response?.data?.detail || 'Could not delete lead'); }
        finally { setBusy(false); }
      }}><Trash2 className="w-4 h-4 mr-2" />Delete lead</Button>}
    </div>
    {enrol && <EnrolModal busy={busy} onClose={() => setEnrol(false)} onSubmit={async body => {
      setBusy(true);
      try { await apiClient.post(`/workflow/leads/${student.id}/enroll`, body); setEnrol(false); await onChanged(); toast.success('Enrolled in Telecaller workflow'); }
      catch (e) { toast.error(e.response?.data?.detail || 'Could not enrol lead'); }
      finally { setBusy(false); }
    }} />}
  </details>;
};